export const connectArc = Symbol.for("connectArc");
export const setter = Symbol("setter");
